module.exports = __webpack_public_path__ + "img/4.031317a3.jpg";